// w2.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W2 = () => {
  return <WW config={pageConfigs.w2} />;
};

export default W2;
